/**
 * Browse Categories — soft slide open/close
 * Prefetch mega HTML so first hover is not waiting on AJAX.
 */
(function ($) {
  'use strict';

  /* Sticky header clones into #header-ontop and drops #header id */
  function kgSel(rest) {
    return (
      '#header.header.style-07 ' +
      rest +
      ', #header-ontop .header.style-07 ' +
      rest
    );
  }
  var SELECTOR_TOGGLE = kgSel('.category-dropdown .kg-submenu-toggle');
  var SELECTOR_DROPDOWN = kgSel('.category-dropdown');
  var SELECTOR_DROPDOWN_MENU = kgSel('.category-dropdown .dropdown-menu');
  var SELECTOR_ITEM = kgSel('.category-dropdown .menu-vertical > li.megamenu-container');
  var SELECTOR_MENU = kgSel('.category-dropdown .dropdown-menu');
  var SELECTOR_MEGALOAD = kgSel('.category-dropdown a.megaload');
  var CLASS_OPEN = 'kg-is-open';
  var CLASS_CLOSING = 'kg-is-closing';
  var SLIDE_MS = 380;
  var CLOSE_DELAY_MS = 180;
  var closeTimer = null;

  function moveMegaToLi($li) {
    $li.find('.kg-bc-row > .megamenu').appendTo($li);
  }

  function setMegaHeight($li) {
    var panel = $li.children('.megamenu').get(0);
    if (!panel) return;
    panel.style.setProperty('--kg-mega-h', panel.scrollHeight + 'px');
  }

  function cancelCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleCloseAll($menu) {
    cancelCloseTimer();
    closeTimer = setTimeout(function () {
      var $items = $menu && $menu.length
        ? $menu.find('li.megamenu-container').filter('.' + CLASS_OPEN + ', .' + CLASS_CLOSING)
        : $(SELECTOR_ITEM).filter('.' + CLASS_OPEN + ', .' + CLASS_CLOSING);

      $items.each(function () {
        closeItem($(this));
      });
      closeTimer = null;
    }, CLOSE_DELAY_MS);
  }

  /** Instantly reset Browse Categories in both normal + sticky headers */
  function hardResetAllMenus() {
    cancelCloseTimer();

    $(SELECTOR_DROPDOWN).each(function () {
      var $dd = $(this);
      $dd.removeClass('show');
      $dd.children('.dropdown-menu').removeClass('show');
      $dd.children('.dropdown-toggle').attr('aria-expanded', 'false');
    });

    $(SELECTOR_ITEM).each(function () {
      var $li = $(this);
      clearAnimTimer($li);
      $li.removeClass(CLASS_OPEN + ' ' + CLASS_CLOSING);
      $li.find('.kg-submenu-toggle').attr('aria-expanded', 'false');
      clearPanelInline($li.children('.megamenu').get(0));
    });
  }

  function watchStickyHeader() {
    var body = document.body;
    if (!body || typeof MutationObserver === 'undefined') return;

    var wasSticky = body.classList.contains('onsticky');
    var observer = new MutationObserver(function () {
      var isSticky = body.classList.contains('onsticky');
      if (isSticky === wasSticky) return;
      wasSticky = isSticky;
      // Sticky clone and original header keep separate open state — reset both on switch
      hardResetAllMenus();
    });

    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  function abortClose($li) {
    if (!$li.hasClass(CLASS_CLOSING)) return;
    clearAnimTimer($li);
    $li.removeClass(CLASS_CLOSING).addClass(CLASS_OPEN);
    var panel = $li.children('.megamenu').get(0);
    if (!panel) return;
    clearPanelInline(panel);
    panel.style.setProperty('--kg-mega-h', panel.scrollHeight + 'px');
    $li.find('.kg-submenu-toggle').first().attr('aria-expanded', 'true');
  }

  function clearAnimTimer($li) {
    var t = $li.data('kgAnimTimer');
    if (t) {
      clearTimeout(t);
      $li.removeData('kgAnimTimer');
    }
  }

  function clearPanelInline(panel) {
    if (!panel) return;
    panel.style.removeProperty('display');
    panel.style.removeProperty('visibility');
    panel.style.removeProperty('position');
    panel.style.removeProperty('max-height');
    panel.style.removeProperty('height');
    panel.style.removeProperty('overflow');
    panel.style.removeProperty('opacity');
    panel.style.removeProperty('transition');
  }

  function measurePanel(panel) {
    panel.style.setProperty('display', 'block', 'important');
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.style.setProperty('position', 'absolute', 'important');
    panel.style.setProperty('max-height', 'none', 'important');
    panel.style.setProperty('height', 'auto', 'important');
    panel.style.setProperty('overflow', 'hidden', 'important');
    var h = panel.scrollHeight;
    panel.style.setProperty('--kg-mega-h', h + 'px');
    return h;
  }

  /** Prefetch / load mega HTML into <li>. Reuses in-flight request. */
  function ensureMega($li, $link) {
    moveMegaToLi($li);

    if ($li.children('.megamenu').length) {
      return $.Deferred().resolve().promise();
    }

    var pending = $li.data('kgMegaPromise');
    if (pending) return pending;

    var url = $link && $link.attr('data-mega');
    if (!url) {
      return $.Deferred().resolve().promise();
    }

    var promise = $.get(url)
      .done(function (data) {
        if ($li.children('.megamenu').length) return;
        var parts = String(data).split('<!-- start -->');
        var html = parts[1] ? parts[1].split('<!-- end -->')[0] : '';
        if (html) {
          $li.append(html);
        }
        moveMegaToLi($li);
      })
      .always(function () {
        $li.removeData('kgMegaPromise');
        $link.removeClass('animated-background load');
      });

    $li.data('kgMegaPromise', promise);
    return promise;
  }

  function prefetchItem($li) {
    if (!$li || !$li.length) return;
    var $link = $li.find('a.megaload').first();
    if (!$link.length) return;
    ensureMega($li, $link);
  }

  function prefetchAll($root) {
    ($root || $(SELECTOR_DROPDOWN)).find('li.megamenu-container').each(function () {
      prefetchItem($(this));
    });
  }

  function openItem($li, $btn, $link) {
    clearAnimTimer($li);
    $li.removeClass(CLASS_CLOSING);
    $btn.attr('aria-expanded', 'true');

    ensureMega($li, $link).always(function () {
      var panel = $li.children('.megamenu').get(0);
      if (!panel) {
        $li.addClass(CLASS_OPEN);
        return;
      }

      var h = measurePanel(panel);

      panel.style.setProperty('visibility', 'visible', 'important');
      panel.style.setProperty('position', 'relative', 'important');
      panel.style.setProperty('opacity', '1', 'important');
      panel.style.setProperty('max-height', '0', 'important');
      panel.style.setProperty('height', 'auto', 'important');
      panel.style.setProperty('overflow', 'hidden', 'important');
      panel.style.setProperty(
        'transition',
        'max-height 0.35s cubic-bezier(0.22, 1, 0.36, 1)',
        'important'
      );

      $li.addClass(CLASS_OPEN);
      void panel.offsetHeight;

      requestAnimationFrame(function () {
        panel.style.setProperty('max-height', h + 'px', 'important');
      });

      $li.data(
        'kgAnimTimer',
        setTimeout(function () {
          clearAnimTimer($li);
          clearPanelInline(panel);
          panel.style.setProperty('--kg-mega-h', h + 'px');
        }, SLIDE_MS)
      );
    });
  }

  function closeItem($li, $btn) {
    var panel = $li.children('.megamenu').get(0);
    clearAnimTimer($li);

    if (!$btn || !$btn.length) {
      $btn = $li.find('.kg-submenu-toggle').first();
    }

    if (!panel) {
      $li.removeClass(CLASS_OPEN + ' ' + CLASS_CLOSING);
      $btn.attr('aria-expanded', 'false');
      return;
    }

    var h = panel.scrollHeight;
    panel.style.setProperty('--kg-mega-h', h + 'px');
    panel.style.setProperty('max-height', h + 'px', 'important');
    panel.style.setProperty(
      'transition',
      'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
      'important'
    );

    $li.removeClass(CLASS_OPEN).addClass(CLASS_CLOSING);
    $btn.attr('aria-expanded', 'false');

    void panel.offsetHeight;
    requestAnimationFrame(function () {
      panel.style.setProperty('max-height', '0', 'important');
    });

    $li.data(
      'kgAnimTimer',
      setTimeout(function () {
        clearAnimTimer($li);
        $li.removeClass(CLASS_CLOSING);
        clearPanelInline(panel);
      }, SLIDE_MS)
    );
  }

  /** Accordion: close any other open/closing item in the same menu */
  function closeOthers($exceptLi) {
    $exceptLi
      .closest('.menu-vertical')
      .children('li.megamenu-container')
      .filter('.' + CLASS_OPEN + ', .' + CLASS_CLOSING)
      .not($exceptLi)
      .each(function () {
        closeItem($(this));
      });
  }

  // Prevent chevron click — submenu opens on hover
  $(document).on('click', SELECTOR_TOGGLE, function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  // Prefetch as soon as user opens Browse Categories
  $(document).on('mouseenter click', kgSel('.category-dropdown > .dropdown-toggle'), function () {
    prefetchAll($(this).closest('.category-dropdown'));
  });

  // Open submenu on hover; close only when leaving the whole dropdown panel
  $(document).on('mouseenter', SELECTOR_MENU, function () {
    cancelCloseTimer();
  });

  $(document).on('mouseleave', SELECTOR_MENU, function () {
    scheduleCloseAll($(this));
  });

  $(document).on('mouseenter', SELECTOR_ITEM, function () {
    var $li = $(this);
    cancelCloseTimer();
    moveMegaToLi($li);
    prefetchItem($li);

    if ($li.hasClass(CLASS_CLOSING)) {
      abortClose($li);
      return;
    }

    if ($li.hasClass(CLASS_OPEN)) return;

    var $btn = $li.find('.kg-submenu-toggle').first();
    var $link = $li.find('a.megaload').first();
    closeOthers($li);
    openItem($li, $btn, $link);
  });

  // Theme may inject mega into .kg-bc-row — keep it under <li> without delayed DOM moves
  $(document).on('mouseenter', SELECTOR_MEGALOAD, function () {
    var $li = $(this).closest('li.megamenu-container');
    moveMegaToLi($li);
    if ($li.hasClass(CLASS_OPEN)) {
      setMegaHeight($li);
    }
  });

  $(document).on('click', SELECTOR_DROPDOWN_MENU, function (e) {
    e.stopPropagation();
  });

  // Homepage: dropdown already open — prefetch immediately
  $(function () {
    $(kgSel('.category-dropdown.show')).each(function () {
      prefetchAll($(this));
    });
    watchStickyHeader();
  });
})(jQuery);
